
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

const WebDevelopmentPage = () => {
  useEffect(() => {
    // SEO設定
    document.title = 'ホームページ制作・運営 | 株式会社伊藤総業 - Webサイト制作';
    
    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "ホームページ制作・運営 - 株式会社伊藤総業",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/web-development`,
      "description": "株式会社伊藤総業のホームページ制作・運営事業。企画から制作、運営・管理まで一貫したWebサービスを提供。",
      "mainEntity": {
        "@type": "Service",
        "name": "ホームページ制作・運営",
        "provider": {
          "@type": "Organization",
          "name": "株式会社伊藤総業"
        },
        "serviceType": "Webサイト制作",
        "areaServed": {
          "@type": "Place",
          "name": "東京都世田谷区"
        }
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
      <Header />
      
      {/* Hero Section */}
      <main>
        <section 
          className="relative h-96 flex items-center justify-center bg-cover bg-center"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/ea01f4c64c95a748b5082e65f822de4e.jpg')`
          }}
        >
          <div className="container mx-auto px-4 text-center text-white">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              ホームページ制作・運営
            </h1>
            <p className="text-xl md:text-2xl max-w-3xl mx-auto">
              企業の魅力を最大限に伝える<br />
              プロフェッショナルなWebサイトを制作
            </p>
          </div>
        </section>

        {/* Services Overview */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">サービス内容</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                企画から制作、運営、管理まで一貫したWebサービスを提供
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="bg-white rounded-xl shadow-lg p-8 text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-layout-line text-blue-600 text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">企画・設計</h3>
                <p className="text-gray-600">
                  お客様のビジネス目標に合わせたWebサイトの企画・設計を行います。
                </p>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-8 text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-code-line text-green-600 text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">制作・開発</h3>
                <p className="text-gray-600">
                  最新技術を活用した高品質なWebサイトの制作・開発を行います。
                </p>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-8 text-center">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-settings-line text-purple-600 text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">運営・管理</h3>
                <p className="text-gray-600">
                  継続的な運営サポートとサイト管理で安定稼働を実現します。
                </p>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-8 text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-line-chart-line text-orange-600 text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">SEO対策</h3>
                <p className="text-gray-600">
                  検索エンジン最適化により、より多くのお客様にリーチします。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-4xl font-bold text-gray-900 mb-6">制作の特徴</h2>
                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-smartphone-line text-blue-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">レスポンシブデザイン</h4>
                      <p className="text-gray-600">
                        PC、タブレット、スマートフォンすべてのデバイスで最適な表示を実現します。
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-speed-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">高速表示</h4>
                      <p className="text-gray-600">
                        最適化されたコードとサーバー環境により、高速なページ表示を実現します。
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                      <i className="ri-shield-check-line text-purple-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">セキュリティ対策</h4>
                      <p className="text-gray-600">
                        最新のセキュリティ対策を実装し、安全なWebサイト運営をサポートします。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="h-96 bg-cover bg-center rounded-xl" style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20responsive%20website%20design%20showcase%20on%20multiple%20devices%2C%20professional%20web%20design%20portfolio%2C%20clean%20user%20interface%20design%2C%20modern%20website%20layouts%20on%20desktop%20tablet%20mobile&width=600&height=400&seq=responsive-design&orientation=landscape')`
              }}></div>
            </div>
          </div>
        </section>

        {/* Website Types */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">制作実績</h2>
              <p className="text-xl text-gray-600">
                様々な業界のWebサイト制作実績
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <div className="h-48 bg-cover bg-center" style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=Corporate%20business%20website%20homepage%20design%2C%20professional%20company%20website%20layout%2C%20clean%20modern%20business%20web%20design%2C%20corporate%20identity%20web%20interface&width=400&height=300&seq=corporate-website&orientation=landscape')`
                }}></div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">コーポレートサイト</h3>
                  <p className="text-gray-600">
                    企業の信頼性を高める、プロフェッショナルなコーポレートサイトを制作します。
                  </p>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <div className="h-48 bg-cover bg-center" style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=E-commerce%20online%20shopping%20website%20design%2C%20modern%20online%20store%20interface%2C%20product%20catalog%20web%20design%2C%20shopping%20cart%20website%20layout&width=400&height=300&seq=ecommerce-website&orientation=landscape')`
                }}></div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">ECサイト</h3>
                  <p className="text-gray-600">
                    売上向上を目指す、使いやすく魅力的なECサイトを構築します。
                  </p>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <div className="h-48 bg-cover bg-center" style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=Landing%20page%20website%20design%20for%20marketing%20campaigns%2C%20conversion%20focused%20web%20design%2C%20promotional%20website%20layout%2C%20marketing%20landing%20page%20interface&width=400&height=300&seq=landing-page&orientation=landscape')`
                }}></div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">ランディングページ</h3>
                  <p className="text-gray-600">
                    コンバージョン率を最大化する、効果的なランディングページを制作します。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">制作の流れ</h2>
              <p className="text-xl text-gray-600">
                お客様と二人三脚で進める制作プロセス
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-6 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                  1
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">ヒアリング</h3>
                <p className="text-gray-600">
                  ご要望と目標を詳しくお聞きします
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                  2
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">企画・提案</h3>
                <p className="text-gray-600">
                  最適なサイト構成をご提案
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                  3
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">デザイン</h3>
                <p className="text-gray-600">
                  魅力的なデザインを制作
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                  4
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">開発・制作</h3>
                <p className="text-gray-600">
                  高品質なサイトを構築
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                  5
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">テスト</h3>
                <p className="text-gray-600">
                  動作確認と最終調整
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                  6
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">公開・運用</h3>
                <p className="text-gray-600">
                  サイト公開と継続サポート
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-blue-600">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              あなたのビジネスを成功に導くWebサイトを
            </h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
              ホームページ制作・運営に関するご相談は、お気軽にお問い合わせください
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/contact" 
                className="bg-white text-blue-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                お問い合わせフォーム
              </Link>
              <a 
                href="tel:070-4228-3984" 
                className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                070-4228-3984
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default WebDevelopmentPage;
